export const equipmentRepairGroups = [
  {
    title: 'Gearboxes, Reducers, and Drives',
    summary: 'Industrial gearbox and reducer repair support for production, processing, handling, and heavy-use equipment.',
    items: [
      'Industrial gearboxes',
      'Gearbox rebuilds',
      'Gearbox inspections',
      'Speed reducers',
      'Speed increasers',
      'Gear reducers',
      'Planetary gearboxes',
      'Worm gear reducers',
      'Helical gearboxes',
      'Bevel gearboxes',
      'Spiral bevel gearboxes',
      'Right-angle gearboxes',
      'Herringbone gearboxes',
      'Split herringbone gearboxes',
      'Cooling tower gearboxes',
      'Conveyor gear reducers',
      'Mixer gearboxes',
      'Agitator gearboxes',
      'Extruder gearboxes',
      'Crane gearboxes',
      'Crusher gearboxes',
      'Mill gearboxes',
      'Rotary kiln drives',
      'Pump drive gearboxes',
    ],
  },
  {
    title: 'Gears and Internal Components',
    summary: 'Repair review for worn or damaged drive components that affect gearbox performance and equipment output.',
    items: [
      'Gear sets',
      'Timing gear sets',
      'Pinions',
      'Bull gears',
      'Bevel gears',
      'Spiral bevel gears',
      'Helical gears',
      'Double helical gears',
      'Herringbone gears',
      'Split herringbone gears',
      'Worm gears',
      'Worm wheels',
      'Spur gears',
      'Gear shafts',
      'Input shafts',
      'Output shafts',
      'Quill shafts',
      'Couplings',
      'Bearings',
      'Bearing seats',
      'Seals',
      'Seal journals',
      'Housings',
      'Covers and end bells',
    ],
  },
  {
    title: 'Hydraulics',
    summary: 'Hydraulic repair and rebuild support for cylinders, components, and systems used in industrial equipment.',
    items: [
      'Hydraulic cylinders',
      'Hydraulic cylinder rebuilding',
      'Hydraulic cylinder rods',
      'Chrome rods',
      'Cylinder barrels',
      'Pistons',
      'Glands',
      'Seal assemblies',
      'Wear bands',
      'Bushings',
      'Pins',
      'Clevis mounts',
      'Trunnion mounts',
      'Mounting points',
      'Hydraulic drift issues',
      'Pressure loss issues',
      'Scored rod review',
      'Bent rod review',
      'Leak repair review',
      'Hydraulic system components',
      'Related mechanical assemblies',
    ],
  },
  {
    title: 'Pumps, Motors, and Cylinders',
    summary: 'Repair support for pump, motor, and cylinder equipment often tied into gearbox, hydraulic, and plant systems.',
    items: [
      'Boiler feed pumps',
      'Positive displacement pumps',
      'Vacuum pumps',
      'Gear pumps',
      'Vertical gear pumps',
      'Vertical turbine pumps',
      'Rectangular flange pumps',
      'Pump housings',
      'Pump drive components',
      'Pump seals',
      'Pump shafts',
      'AC motors',
      'DC motors',
      'Motor repair review',
      'Motor rewind inquiries',
      'Pneumatic cylinders',
      'Pneumatic jacks',
      'Industrial cylinders',
      'Cylinder repair assemblies',
    ],
  },
  {
    title: 'Mills, Kilns, and Processing Equipment',
    summary: 'Repair support for rotating and driven equipment used in mills, process plants, and heavy industrial facilities.',
    items: [
      'Ball mill drives',
      'Ball mill gears',
      'Ball mill pinions',
      'Crusher mill drives',
      'Crusher mill gears',
      'Crusher mill pinions',
      'Hammer mill drives',
      'Hammer mill gears',
      'Hammer mill pinions',
      'Raymond mill drives',
      'Raymond mill gears',
      'Raymond mill pinions',
      'SAG mill drives',
      'SAG mill gears',
      'SAG mill pinions',
      'Rotary kiln gears',
      'Rotary kiln pinions',
      'Dragline timing gear sets',
      'Shovel timing gear sets',
      'Aggregate equipment',
      'Cement equipment',
      'Gypsum and lime equipment',
      'Sand and gravel equipment',
    ],
  },
  {
    title: 'Production and Plant Equipment',
    summary: 'Equipment used in manufacturing, material handling, plastics, food processing, agriculture, and energy environments.',
    items: [
      'Conveyors',
      'Conveyor drives',
      'Mixers',
      'Agitators',
      'Extruders',
      'Blow molding equipment',
      'Injection molding equipment',
      'Thermoforming equipment',
      'Rubber processing equipment',
      'Tire industry equipment',
      'Food processing equipment',
      'Beverage processing equipment',
      'Flour mill equipment',
      'Sugar mill equipment',
      'Vegetable oil processing equipment',
      'Fruit processing equipment',
      'Tomato processing equipment',
      'Material handling equipment',
      'Lifting equipment',
      'Heavy equipment components',
      'Agricultural processing equipment',
      'Power generation equipment',
      'Water treatment equipment',
    ],
  },
  {
    title: 'Common Gearbox Failure Symptoms',
    summary: 'Symptoms that often point to a gearbox, reducer, or drive component repair need.',
    items: [
      'Abnormal noise',
      'Grinding sounds',
      'Whining sounds',
      'Clunking sounds',
      'Excess vibration',
      'Overheating',
      'Burnt or dark lubricant',
      'Oil leaks',
      'Worn seals',
      'Metal shavings in oil',
      'Oil contamination',
      'Reduced output speed',
      'Loss of torque',
      'Backlash',
      'Misalignment',
      'Bearing failure',
      'Gear tooth damage',
      'Shaft wear',
      'Housing damage',
      'Repeated component failure',
    ],
  },
  {
    title: 'Common Hydraulic Failure Symptoms',
    summary: 'Symptoms that often point to hydraulic cylinder, seal, rod, or system component repair needs.',
    items: [
      'External oil leaks',
      'Internal bypassing',
      'Cylinder drift',
      'Loss of pressure',
      'Weak movement',
      'Slow operation',
      'Jerky cylinder travel',
      'Scored rods',
      'Bent rods',
      'Damaged chrome',
      'Worn seals',
      'Damaged glands',
      'Worn bushings',
      'Loose pins',
      'Damaged mounts',
      'Contaminated hydraulic oil',
      'Heat buildup',
      'Unexpected downtime',
    ],
  },
];

export const gearboxBrands = [
  'AARON',
  'Alten',
  'Amarillo',
  'Ball Mill Pinion',
  'Barber Greene',
  'Baulmuller Numberg',
  'Black Clawson',
  'Bohmer',
  'Bonfiglioli',
  'Brevini',
  'Browning',
  'California Pellet Mill',
  'Camco Ferguson',
  'Cincinnati Milacron',
  'Cleveland Gear',
  'Cone Drive',
  'Coperion',
  'Cushman',
  'Dango & Dienenthal',
  'David Brown',
  'Davis Standard',
  "De'Ran",
  'Desch',
  'DieQua',
  'Dodge',
  'Dover',
  'Drive All',
  'Dyun',
  'Eagle Iron Works',
  'Egan',
  'Eisenbeiss',
  'Erema',
  'Falk',
  'Flender',
  'Foote-Jones',
  'Gamesa',
  'GE',
  'Gloucester',
  'Hansen',
  'Horsburgh & Scott',
  'Hosokawa',
  'Ingersoll Rand',
  'Jahnel-Kestermann',
  'Jupiter',
  'Kissling',
  'Knodler',
  'Koellmann',
  'Konecranes',
  'KraussMaffei',
  'Leistritz',
  'Liebherr',
  'Lightnin',
  'Link-Belt',
  'Lohmann',
  'Lufkin',
  'Marley',
  'Master Electric Co.',
  'McLanahan',
  'Metso Sterling',
  'Motovario',
  'Nabtesco',
  'Neptune',
  'Nicco',
  'Nord',
  'NRM',
  'Nuttall',
  'Ohio Gear',
  'P&H',
  'Philadelphia Gear',
  'PIV Drive',
  'Planetary',
  'Rademaker',
  'Raymond Mill',
  'Reggiana Riduttori',
  'Rexnord',
  'Rome Grinding Solutions',
  'Rossi',
  'Santasalo',
  'Saturn',
  'SEW-Eurodrive',
  'Sterling',
  'Sumitomo',
  'Symetro',
  'Tandler',
  'Terex Comedil',
  'Thyssen',
  'Titan',
  'Toshiba',
  'Voeller',
  'Voith',
  'Weiler',
  'Werner Pfleiderer',
  'Westech',
  'Western Gear',
  'Windmoeller & Hoelscher',
  'Winsmith',
  'Zahnradafabrik Friedrichshafen',
  'Zambello',
  'ZPMC',
  'Zond',
];

export const marqueeBrandLogos = [
  { name: 'Dodge', file: 'dodge.svg' },
  { name: 'Falk', file: 'falk.svg' },
  { name: 'Flender', file: 'flender.svg' },
  { name: 'SEW-Eurodrive', file: 'sew-eurodrive.svg' },
  { name: 'Sumitomo', file: 'sumitomo.svg' },
  { name: 'Bonfiglioli', file: 'bonfiglioli.svg' },
  { name: 'Nord', file: 'nord.svg' },
  { name: 'Rexnord', file: 'rexnord.svg' },
  { name: 'Philadelphia Gear', file: 'philadelphia-gear.svg' },
  { name: 'David Brown Santasalo', file: 'david-brown-santasalo.svg' },
  { name: 'Hansen', file: 'hansen.svg' },
  { name: 'Lufkin Gears', file: 'lufkin-gears.svg' },
  { name: 'Cone Drive', file: 'cone-drive.svg' },
  { name: 'Cleveland Gear', file: 'cleveland-gear.svg' },
  { name: 'Horsburgh & Scott', file: 'horsburgh-and-scott.svg' },
  { name: 'Winsmith', file: 'winsmith.svg' },
  { name: 'Rossi', file: 'rossi.svg' },
  { name: 'Brevini', file: 'brevini.svg' },
  { name: 'Amarillo Gear Company', file: 'amarillo-gear-company.svg' },
  { name: 'Marley', file: 'marley.svg' },
];
